.container {
    position: relative;
    color: var(--ink);
    padding: 16px;
    display: flex;
    flex-direction: row;
    gap: 8px;
}

.close {
    border: 0;
    background: transparent;
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    cursor: pointer;
}

.margin-right-24 {
    margin-right: 24px;
}

.line-height-24 {
    line-height: 24px;
}

.success {
    background-color: var(--lime-lighter);
}

.information {
    background-color: var(--blue-lighter);
}

.warning {
    background-color: var(--orange-lighter);
}

.error {
    background-color: var(--red-lighter);
}
